import Card from '../payment/card';
import User from '../user/user';
import Payer from './payer';

export default class CreditCart {
  public token?: string;
  public issuerId?: string;
  public paymentMethodId?: string;
  public transactionAmount?: number;
  public installments?: number;
  public description?: string;
  public payer?: Payer;

  constructor(user: User, card: Card) {
    if (card?.cardNumber) {
      this.token = card.token;
      this.issuerId = card.issuerId;
      this.paymentMethodId = card.paymentMethodId;
      this.installments = card.installments;
      this.transactionAmount = card.transactionAmount;
      this.description = 'Pedido realizado para ' + user?.name;
      this.payer = new Payer(user, card);
    }
  }
}
